import { Address } from 'viem';

export const NFT_BONDS: Address = '0x9Bb53af9023b6BB8313229679a012e4A8E1Ae638';
export const NFT_REDEMPTION: Address =
  '0xAd9a230437bfa944977cC45A3dbFD81446258c3A';
export const REWARD_POOL: Address =
  '0x5C2a2C52d1368974E988254A5A2C0b74aB1A736f';
